import axios from '@/plugins/axios'

import { useAuthorizationStore } from '@/store/authorizationStore'

const getWorkspaceId = () => useAuthorizationStore().getWorkspaceSlug

const getModifiers = ({ slug, params }) => axios.get(`${getWorkspaceId()}/campaigns/${slug}/rtb-settings/bid-modifier/conditions`, { params })
const updateModifiers = ({ slug, formData }) => axios.patch(`${getWorkspaceId()}/campaigns/${slug}/rtb-settings/bid-modifier/conditions`, formData)
const deleteModifiers = ({ slug, data }) => axios.delete(`${getWorkspaceId()}/campaigns/${slug}/rtb-settings/bid-modifier/conditions`, { data })
const deleteAllModifiers = ({ slug, data }) => axios.delete(`${getWorkspaceId()}/campaigns/${slug}/rtb-settings/bid-modifier/conditions/clear`, { data })
const uploadCsvForModifier = ({ formData, config }) => axios.post(`${getWorkspaceId()}/campaigns/rtb-settings/bid-modifier/conditions/file`, formData, config)
const downloadFileExampleModifier = () => axios.get(`${getWorkspaceId()}/campaigns/rtb-settings/bid-modifier/conditions/file-example`)

export {
    getModifiers,
    updateModifiers,
    deleteModifiers,
    deleteAllModifiers,
    uploadCsvForModifier,
    downloadFileExampleModifier,
}
